<template>
    <FullFillBox
        :pageID="1008"
        @permissionData="(data) => {
                this.permissionDetails = data
            }"
    >
        <h5>{{ $t('inventory_stock_excel_upload') }}</h5>
        <div class="rap-image" style="margin: 10px">
            <img :src="simpleImageSrc" alt="excel_format_simple" style="height: 80%">
        </div>
        <p>
            {{ $t('product_upload_select_file') }}
            <span>
                    <input type="file" @change="selectExcelFile($event)"
                           accept=".xls,.xlsx" id="inputExcel">
                </span>
            <button class="btn btn-primary" v-if="getInputExcel" @click="uploadExcel('review')">
                {{ $t('common_review') }}
            </button>
        </p>
        <hr>
        <hr>
        <p class="error-text" v-if="errorTitle">{{ errorTitle }}</p>
        <div class="rag-image" id="tableDiv">
            <h6 class="error-text">
                <span style="color: black">{{ $t('product_upload_total_row') }} {{ excelTotalRow }} ;</span>
                {{ excelDetails }}
            </h6>
            <p>
                <button class="btn btn-warning" type="button"
                        data-bs-toggle="collapse" data-bs-target="#collapseExample"
                        aria-expanded="false" aria-controls="collapseExample">
                    {{ $t('error_expand_error_details') }}
                </button>
            </p>
            <div class="collapse" id="collapseExample">
                <div v-if="isError">
                    <div v-for="(value, key) in excelRowDetails">
                        <div class="row" style="border: #2c3e50 1px solid">
                            <div class="col-4"><p>{{ $t('common_row') }} : {{ value['row'] }}</p></div>
                            <div class="col-8">
                                <h6>{{ value['errors'] }}</h6>
                                <p v-for="(v, k) in value['details']">
                                    <span><strong>{{ k + 1 }}</strong></span> :
                                    <span class="error-text" v-for="(v2, k2) in v"> {{ k2 }} : {{ v2 }} ;</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr>
            <button class="btn btn-primary" type="button"
                    @click="uploadExcel('save')" id="common_upload"
                    style="margin: auto"
            >
                {{ $t('common_upload') }}
            </button>
            <hr>
            <div ref="tabulatorTableUse"></div>
        </div>
    </FullFillBox>
</template>

<script>
import FullFillBox from "@/components/routerViewLocation/FullFillBox";
import {TabulatorFull as Tabulator} from "tabulator-tables";

export default {
    name: "InventoryImportExcelView",
    components: {
        FullFillBox,
    },
    data(){
        return{
            permissionDetails: {},
            simpleImageSrc: '',
            getInputExcel: '',
            excelTotalRow: '',
            excelDetails: '',
            excelRowDetails: '',
            errorsRowList: '',
            errorTitle: '',
            isError: false,
        }
    },
    methods: {
        selectExcelFile(e){
            this.getInputExcel = e.target.files.item(0)
        },
        async uploadExcel(getMode) {
            this.$store.commit('setIsTopLoading', true)

            // Reset data
            this.resetAllDataError()

            let postData = {
                "excel": this.getInputExcel,
                "mode": getMode
            }
            await this.uploadServer(postData)
            this.$store.commit('setIsTopLoading', false)
        },
        async uploadServer(postData){
            await this.$mainApi.post('api/inventory/import/', postData, {
                headers: {
                    "content-type": "multipart/form-data"
                }
            })
                .then(async response => {
                    if (response.data.status === 80) {
                        console.log(response.data.details)
                        await this.processOnReturnData(response)
                        if(response.data.errors.errors_row.length === 0 && postData.mode === "save"){
                            // No Errors and serializer save successfully
                            this.$toast.success(this.$t('common_success'))
                            this.$router.push(`/inventory`)
                        }else if(response.data.errors.errors_row.length > 0 && postData.mode === "save"){
                            this.tabulator.setData(this.tabulator.getData().filter(a => this.errorsRowList.includes(a.row)))
                        }
                    } else {
                        this.errorTitle = response.data.errors
                    }
                })
        },
        async processOnReturnData(response){
            document.getElementById('tableDiv').style.display = 'block'
            this.errorsRowList = response.data.errors.errors_row
            this.excelTotalRow = response.data.details.total_row
            this.excelDetails = this.$t('error_error_list')
            for(let e=0;e<this.errorsRowList.length;e++){
                if(e === this.errorsRowList.length-1){
                    this.excelDetails += this.errorsRowList[e]
                }else{
                    this.excelDetails += this.errorsRowList[e] + ", "
                }
            }

            this.tabulator.setData(response.data.details.data)

            this.isError = true
            this.excelRowDetails = response.data.errors.errors_details

        },
        getHeaderMenu(){
            return this.$getHeaderMenu(this.tabulator)
        },
        delTableItem(getID){
            this.$swal.fire({
                title: this.$t('common_confirm_action_delete'),
                icon: "info"
            }).then((result) => {
                if(result.isConfirmed){
                    this.tabulator.setData(this.tabulator.getData().filter(a => a.id !== getID))
                }
            })
        },
        resetAllDataError(){
            // Reset data
            this.excelDetails = ""
            this.errorTitle = ""
            this.errorsRowList = ""
            this.excelRowDetails = ""
            document.getElementById('tableDiv').style.display = 'none'
            document.getElementById('common_upload').style.display = 'block'
        },
    },
    mounted() {
        document.title = this.$t('title') + ' | ' + this.$t('inventory_stock_excel_upload')

        this.tabulator = new Tabulator(this.$refs.tabulatorTableUse, {
            placeholder: "<h3>" + this.$t('common_no_data') + "</h3>",
            data: [],
            columns: [
                {title: this.$t('table_row'), field: 'row', sorter: 'number', resizable:false,
                    width:80, responsive:0,
                    headerFilter:"list",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: this.$t('table_location'), field: 'location', sorter: 'number', resizable:false,
                    responsive:0,
                    headerFilter:"list",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: this.$t('table_area'), field: "area", sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2,
                    headerFilter:"list",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: this.$t('table_outCode'), field: "outCode", sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2,
                    headerFilter:"list",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: this.$t('table_innerCode'), field: "innerCode", sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, visible: false,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: this.$t('table_nameEn'), field: "name_en", sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: this.$t('table_nameZh'), field: "name_zh", sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, visible: false,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: this.$t('table_qty'), field: "qty", sorter: 'number', resizable:false,
                    responsive:1, widthGrow: 2,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: this.$t('table_ctn'), field: "ctn", sorter: 'number', resizable:false,
                    responsive:1, widthGrow: 2,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: this.$t('table_inner_packing'), field: "inner_packing", sorter: 'number', resizable:false,
                    responsive:1, widthGrow: 2,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: this.$t('table_outer_packing'), field: "outer_packing", sorter: 'number', resizable:false,
                    responsive:1, widthGrow: 2,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: this.$t('table_remarks'), field: "remarks", sorter: 'number', resizable:false,
                    responsive:1, widthGrow: 2,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {formatter: () => {return "<i class='bi bi-trash-fill'></i>"},
                    headerHozAlign:"center", hozAlign:"center", vertAlign: "middle", resizable:false,
                    headerMenu: this.getHeaderMenu,
                    headerSort:false, width:10, responsive:0,
                    cellClick: (e, row, formatterParams) => {
                        this.delTableItem(row.getData().id)
                    }
                },
            ],
            reactiveData: true, //enable data reactivity
            maxHeight: '90vh',
            responsiveLayout: 'collapse',
            layout: "fitColumns",
            movableColumns:true,
            movableRows: false,
            initialSort: [
                {column:"row", dir:"asc"},
            ],
            rowFormatter: (row, e) => {
                if(row.getData().is_error === true){
                    row.getElement().style.backgroundColor = "#fac3c3"
                }
            }
        })
        document.getElementById('tableDiv').style.display = 'none'
        this.simpleImageSrc = this.$store.state.serverIp + this.$store.state.serverMediaPath + 'website/images/inventory_excel_simple.jpg' + '?' + new Date()
    }
}
</script>

<style scoped>

</style>
